import { Yup, TRANSLATION } from  '@/imports-files/pages/clients/jobs/scorecards';


export function scorecard_config_initials(){
  return SCORECARD_CONFIG_ATTRIBUTES_HASH
}

export function job_competency_initials(){
  return JOB_COMPETENCY_ATTRIBUTES_HASH
}

export var SCORECARD_CONFIG_ATTRIBUTES_HASH = {
                                                 job_id: '',
                                                 link: false,
                                                 private: false, 
                                                 scorecard_link:'', 
                                                 instructions:'',
                                                 is_imported: false
                                              }

export var JOB_SUB_COMPETENCIES_COMPETENCY_ATTRIBUTES_HASH =  { 
                                                                name: ''
                                                              }

export var JOB_COMPETENCY_ATTRIBUTES_HASH = {
                                  _destroy: false,
                                  notes: '',
                                  name: '',
                                  job_sub_competencies_attributes:[]
                                }


export const INITIAL_VALUES = {
                                 scorecard_config_attributes: SCORECARD_CONFIG_ATTRIBUTES_HASH,
                                 job_competencies_attributes: [JOB_COMPETENCY_ATTRIBUTES_HASH]
                              }

export function job_competency_attr_hash() {
  return {
          _destroy: false,
          notes: '',
          name: '',
          job_sub_competencies_attributes:[]
        }
}

export function getValidationSchema(submitState, job_status){
  let validationRequired = !(submitState == 'draft' || (submitState == 'preview' && job_status != 'active'))
  return Yup.object({
    is_job_competency_visible: Yup.boolean(),
    job_competencies_attributes:Yup.array().of(
      Yup.object({
        _destroy: Yup.boolean(),
        name: Yup.string().when("_destroy",{
          is: (_destroy) => {
            return !_destroy && validationRequired },
          then: Yup.string().required(TRANSLATION('common:errors:required')).nullable(true),
          otherwise: Yup.string().notRequired().nullable(true)
        }),
        job_sub_competencies_attributes: Yup.array().of(
          Yup.object({
            _destroy: Yup.boolean(),
             name: Yup.string().when("_destroy",{
              is: (_destroy) => {
                return !_destroy && validationRequired },
              then: Yup.string().required(TRANSLATION('common:errors:required')).nullable(true),
              otherwise: Yup.string().notRequired().nullable(true)
            }),
          })
        )
      })
    )
  })
}
